import React from 'react'

import { Box, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import CalendarDay from './CalendarDay'
import { WeekObject } from '../../../../screens/App/FamilyMember/FamilyCalendar/Calendar'
import { useSelector } from 'react-redux'
import { getPrefersDarkMode } from '../../../../store/settings/settings.selectors'

interface IProps {
  index: number
  week: WeekObject
  selectedDate?: number
  calendarData?: any
  changeSelectedDate?: (date: number) => void
  setSelectedDate?: (selectedDate: number) => void
}

const CalendarWeek: React.FC<IProps> = ({ week, index, ...props }) => {
  const darkMode = useSelector(getPrefersDarkMode)

  const useStyles = makeStyles((theme: Theme) => ({
    calendarDaysRow: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: `1px solid ${darkMode ? '#8a8a8a' : '#f5f5f5'}`,
    },
  }))
  const classes = useStyles()
  return (
    <Box key={index} className={classes.calendarDaysRow} component='div'>
      {week.days.map((day, i) => {
        return (
          <CalendarDay
            key={i}
            index={i}
            day={day}
            calendarData={props.calendarData}
            setSelectedDate={props.setSelectedDate}
          />
        )
      })}
    </Box>
  )
}

export default CalendarWeek
